export type LocaleCode = 'en' | 'de' | 'es' | 'fr' | 'pt';

export type LocaleParam = { locale: string };

export type LocalizedRouteParams<T extends Record<string, string> = Record<never, never>> = Promise<
  T & LocaleParam
>;

export type LocalizedPageProps<T extends Record<string, string> = Record<never, never>> = {
  params: LocalizedRouteParams<T>;
};

export type LocalePrefix = 'always' | 'as-needed';

export const defaultLocale: LocaleCode = 'en';

export const locales = ['en', 'de', 'es', 'fr', 'pt'] as const satisfies readonly LocaleCode[];

export const localePrefix: LocalePrefix = 'as-needed';

export function isLocaleCode(locale: string): locale is LocaleCode {
  return (locales as readonly string[]).includes(locale);
}

export function resolveLocale(locale: string): LocaleCode {
  return isLocaleCode(locale) ? locale : defaultLocale;
}
